<template>
  <div class="q-px-md desktop-single-column full-width">
    <SAIBreadcrumbs
      class="print-hide q-pt-md"
      :breadcrumbs="breadcrumbs"
      v-if="breadcrumbs.length"
    />
    <h4
      v-if="title"
      :class="[
        'text-grey-10 text-weight-medium print-hide',
        {
          'q-py-md': $q.screen.xs,
          'q-py-lg': !$q.screen.xs
        }
      ]"
    >
      {{ title }}
    </h4>
    <slot />
  </div>
</template>

<script>
import { SAIBreadcrumbs } from 'ecx.saigon.ui.common';

export default {
  name: 'BreadcrumbPageHeader',
  props: {
    breadcrumbs: {
      type: Array,
      default: () => []
    },
    title: String
  },
  components: {
    SAIBreadcrumbs
  }
};
</script>
